export const FIELD_NAME_BILLING_FORECAST_DATE = 'billingForecastDate';
export const FIELD_NAME_CUSTOMER_ORDER_CODE = 'customerOrderCode';
export const FIELD_NAME_PRIORITY_CODE = 'priorityCode';
